





















































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import {
  pagination,
  loadingCatch,
  loading,
  SearchbarControl,
  IsMore
} from "@root/lib/decorator";
import {formDownload} from '@/lib/common'
import {API_URL} from '@/lib/axios'

import RemoteSelect from "@/components/custom/RemoteSelect.vue";

const common = namespace("common");
const rootVuex = namespace("root");
const warehousingCheckVuex = namespace("warehousingCheck");
const Order = namespace("wtOrder");
@Component({ components: {RemoteSelect} })
@pagination("getData", {
  pageSize: 50
})
@SearchbarControl()
@loading()
@IsMore(true)
export default class InventoryQuery extends Vue {
  @rootVuex.State ddCodes;
  @warehousingCheckVuex.Action getRecordList;
  @Order.Action queryBaseStorePage;

  private dataList = [];

private form = {
  date: [],
  orderCode: "",
  tyreCode: "",
  storeCode: ""
};
tabList: any = [];
importFailData: any = {};
templateUrl: any =
  "https://cn-gtech-wintogether.oss-cn-shanghai.aliyuncs.com/template/%E9%97%A8%E5%BA%97APP%E5%8A%9F%E8%83%BD%E9%BB%91%E5%90%8D%E5%8D%95%E6%A8%A1%E6%9D%BF.xlsx";

pickerMinDate: any = null; // 保存选中的开始时间
get pickerOptions() {
  let result: any = {
    onPick: obj => {
      this.pickerMinDate = new Date(obj.minDate).getTime();
    },
    disabledDate: time => {
      if (this.pickerMinDate) {
        const diff = 1000 * 3600 * 24 * 90;
        const maxTime = this.pickerMinDate + diff;
        const mixTime = this.pickerMinDate - diff;
        return time.getTime() >= maxTime || time.getTime() < mixTime;
      }
    }
  };
  return result;
}

async created() {
  this.getDefaultDate();
  Promise.all([this.getData(), this.getDicData()]);
}
orderStatusMap: any = {};
async getDicData() {
  await this.$dd
    .register([
      "INOUT_INVENTORY_STATUS",
      "VERIFICATION_STATUS",
      "ORDER_STATUS"
    ])
    .query();
  this.ddCodes.ORDER_STATUS.forEach(_ => {
    if (_.value.indexOf(",") > -1) {
      let list = _.value.split(",");
      list.forEach(i => {
        this.orderStatusMap[i] = _.label;
      });
    } else {
      this.orderStatusMap[_.value] = _.label;
    }
  });
  console.log(
    this.ddCodes.ORDER_STATUS,
    this.orderStatusMap,
    "--this.ddCodes.ORDER_STATUS"
  );
}
// 格式化时间
formatDate(datetime) {
  const time = new Date(datetime);
  const year = time.getFullYear();
  const month = (time.getMonth() + 1).toString().padStart(2, "0");
  const date = time
    .getDate()
    .toString()
    .padStart(2, "0");
  return year + "-" + month + "-" + date;
}
getDefaultDate() {
  const start = new Date();
  this.$set(
    this.form.date,
    0,
    this.formatDate(start.getTime() - 1000 * 3600 * 24 * 90) + " 00:00:00"
  );
  this.$set(
    this.form.date,
    1,
    this.formatDate(start.getTime()) + " 23:59:59"
  );
}

createSearchCondition() {
  const { pageSize, currentPage: pageNum } = this as any;
  const { date, storeCode, orderCode, tyreCode } = this.form;

  let input: any = {
    orderCode,
    storeCode,
    tyreCode,
    pageSize,
    pageNum
  };
  if (date && date[0]) {
    input.createTimeFrom = date[0];
    input.createTimeTo = date[1];
  }
  return input;
}

@loadingCatch
async getData() {
  let { total, list } = await this.getRecordList(
    this.createSearchCondition()
  );
  (this as any).total = total;
  this.dataList = list;
}

tabToggleHandle(status) {
  this.$set(this.form, "status", status);
  (this as any).onSearchBtnClick();
}
// 跳转新建页面
goCreatePageFn() {
  this.$router.push({
    name: "blacklistCreate"
  });
}
// 跳转编辑页面
jumpEditFn(row) {
  this.$router.push({
    name: "blacklistEdit",
    params: {
      code: row.code
    }
  });
}

// 导出
exportFn() {
  // /scanStoreVerificationOrderRecord/export
  let params: any = this.createSearchCondition();
  delete params.pageNum;
  delete params.pageSize;
  formDownload(`${API_URL}/scanStoreVerificationOrderRecord/export`, {
    ...params
  });
}
}
